import {useLoaderData, useNavigate} from 'react-router-dom';
import React, {useState, useEffect} from "react";
import { useUser } from "../components/UserContext";
import { getUser, editUserDetails, initialiseBaseSkins, login2, newEmailAndPassword } from '../Users'
import Colors from '../components/Colors';
// import SettingsIcon from '@mui/icons-material/Settings';
import FileUpload from '../components/FileUpload';

export async function loader({params}) {
    const userId = params.userId;
    const user = await getUser(userId);
    if (!user) {
        throw new Response("", {
            status: 404,
            statusText: "Not Found",
        });
    }
    return {user};
}

export default function Settings() {
    const navigate = useNavigate();
    const {user} = useLoaderData();
    const {currentUser} = useUser();
    const [target, setTarget] = useState({location: [], method: "edit"});
    const [input, setInput] = useState({username: "", pfp: "", groupOrder: 0, 
        highlightColors: ['transparent', '#ffffff', '#cccccc', '#999999', '#666666', '#333333', '#000000' ], email: "", password: "",
        pageColors: ["#4468a2", "#f2f4f8", "#f6f9fd", "#dce1ea", "#5a677c"]});
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => { //initialize
        document.title = `settings`;
        initialiseBaseSkins(currentUser.id);
        if (user) {
            setInput({username: user.username, pfp: user.pfp, groupOrder: user.groupOrder, 
                highlightColors: JSON.parse(user.highlightColors.replace(/'/g, '"')), email: '', password: '',
                pageColors: JSON.parse(user.pageColors.replace(/'/g, '"'))});
        }
    }, [user, currentUser.id]);


    function handleChange(event) {
        const { name, value, type, checked } = event.target;
        setInput(prevInput => ({
            ...prevInput,
            [name]: type === "checkbox"? (checked ? 1 : 0) : value
        }));
    }

    function removePfp() {
        setInput(prevInput => ({
            ...prevInput,
            pfp: null
        }));
    }

    function handlePageColorChange(event) {
        const { name, value } = event.target;
        const index = parseInt(name, 10); // Get the index from the name attribute
        
        setInput(prevInput => ({
            ...prevInput,
            pageColors: prevInput.pageColors.map((color, i) => 
                i === index ? value : color // Only update the color at the specific index
            )
        }));
    }

    function setToDefault() {
        setInput(prevInput => ({
            ...prevInput,
            pageColors: ["#4468a2", "#f2f4f8", "#f6f9fd", "#dce1ea", "#5a677c"]
        }));
    }

    function setToPrevious() {
        setInput(prevInput => ({
            ...prevInput,
            pageColors: JSON.parse(user.page_colors.replace(/'/g, '"'))
        }));
    }

    function edit(newItem) { //replace function
        editUserDetails(currentUser.id, newItem);//replace
        window.location.reload();
    }

    function submit() {
        if(input.username.length === 0) return;
        if (target.method === "edit") {
            const newItem = {
                username: input.username,
                pfp: input.pfp,
                group_order: input.groupOrder,
                highlight_colors: input.highlightColors,
                page_colors: input.pageColors
            }
              edit(newItem);
              setTarget((prev) => ({...prev, method : null}));
          }
    }

    function handleSensChangeClick() {
        setTarget({location: [], method: "updateSens"})
    }

    async function verify() {
        if (target.method === "updateSens") {
            const values = {email: input.email, password: input.password}
            try {
                setErrorMessage('');
                const login = await login2(values);
                if (login) {
                    setInput(prev => ({...prev, password: ''}))
                    setTarget({location: [], method: "verifiedUpdate"})
                    setErrorMessage('success! now you can enter your new password and/or email. Once you submit, you will be logged out.')
                } else {
                    setErrorMessage('incorrect username or password');
                }
            } catch (error) {
                console.error('Error:', error);
                setErrorMessage('incorrect username or password');
                setTimeout(() => {
                    setErrorMessage('')
                }, "2500");
            }
        } else {
            const values = {email: input.email, password: input.password, userId: currentUser.id}
            try {
                setErrorMessage('');
                const changed = await newEmailAndPassword(values)
                if (changed) {
                    setErrorMessage('your details have been changed successfully! all sessions of your account will now end.');
                    setTimeout(() => {
                        navigate('/login')
                    }, 1000);
                }
            } catch (error) {
                console.error('Error:', error);
                setErrorMessage('an error has occurred. please try again.');
                setTimeout(() => {
                    setErrorMessage('')
                }, "2500");
            }
        }
    }

    if (user.id === currentUser.id) return(
        <div>
            <div className="page-head">
                <div className="page-title settings-title">
                    <div className="creator-pfp">
                        {/* <SettingsIcon className="creator-default-pfp"/> */}
                        </div>
                    <h2 className="title-text">settings</h2>
                    <h3>change preferences and user information</h3>
                </div>
            </div>
            <div>
                <div id="folder-create-container">
                    <div id="skin-create">
                        <div>
                            <div id="settings-sec-1">
                                <div>
                                    <label> username:  
                                        <input name="username" onChange={handleChange} value={input.username} placeholder="username" type="text"/>
                                    </label>
                                    <label> group render order: 
                                        <select name="groupOrder" onChange={handleChange} value={input.groupOrder}>
                                            <option value="1">more recent groups at the bottom of the page</option>
                                            <option value="0">more recent groups at the top of the page</option>
                                        </select>
                                    </label>
                                    {target.method === "edit" && 
                                        <button className="settings-button" onClick={handleSensChangeClick}>change email or password</button>}
                                    {(target.method === "updateSens" || target.method==="verifiedUpdate") &&
                                    <div id="settings-email-change">
                                        <p>{errorMessage}</p>
                                        <label> {target.method === "updateSens"? "current email:" : "new email"}  
                                            <input name="email" onChange={handleChange} value={input.email} placeholder={target.method === "updateSens"? "Current email:" : "New email"} type="text"/>
                                        </label>
                                        <label> {target.method === "updateSens"? "current password:" : "new password"}  
                                            <input name="password" onChange={handleChange} value={input.password} placeholder={target.method === "updateSens"? "Current password:" : "New password"} type="password"/>
                                        </label>
                                        <button className="settings-button" onClick={verify}>submit</button>
                                    </div>}
                                </div>
                                <div>
                                    <label>profile picture: </label>
                                    <FileUpload type="pfp" input={input} setInput={setInput}/>
                                    <button className="pfp-settings-button settings-button" onClick={removePfp}>remove profile picture</button>
                                </div>
                            </div>
                        </div>

                        <div id="settings-colors-sec">
                            <div id="page-colors">
                                <div>page colours:</div>
                                <label> Colour 1 (e.g. logo):  
                                    <input name="0" onChange={handlePageColorChange} value={input.pageColors[0]} placeholder="colour" type="color"/>
                                </label>
                                <label> Colour 2 (e.g. main header):  
                                    <input name="1" onChange={handlePageColorChange} value={input.pageColors[1]} placeholder="colour" type="color"/>
                                </label>
                                <label> Colour 3 (e.g. input's backgrounds):  
                                    <input name="2" onChange={handlePageColorChange} value={input.pageColors[2]} placeholder="colour" type="color"/>
                                </label>
                                <label> Colour 4 (e.g. search bar):  
                                    <input name="3" onChange={handlePageColorChange} value={input.pageColors[3]} placeholder="colour" type="color"/>
                                </label>
                                <label> Colour 5 (e.g. text of the search bar):  
                                    <input name="4" onChange={handlePageColorChange} value={input.pageColors[4]} placeholder="colour" type="color"/>
                                </label>
                                <div className="page-color-buttons-container">
                                    <button className="settings-button" onClick={setToDefault}>reset to default</button>
                                    <button className="settings-button" onClick={setToPrevious}>reset to previous values</button>
                                </div>
                            </div>
                            <div>
                                <Colors input={input} setInput={setInput} user={user}/>
                            </div>
                        </div>

                        <div id="skin-submit-container">
                            <div>
                                <button id="folder-submit-button" className="settings-button" onClick={submit}>Submit</button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}